import { HTTP_STATUS } from '../response';

export interface ChangePasswordRequest {
	oldPassword: string;
	newPassword: string;
}

export enum ChangePasswordError {
	Unauthorized = 'Unauthorized',
	EmailInvalid = 'EmailInvalid',
	Invalid = 'Invalid'
}

export interface ChangePasswordSuccessResponse {
	status: HTTP_STATUS;
}

export interface ChangePasswordErrorResponse {
	status: HTTP_STATUS;
	error?: ChangePasswordError;
}

export type ChangePasswordResponse = ChangePasswordSuccessResponse | ChangePasswordErrorResponse;

export type PasswordChangeAction = (
	request: ChangePasswordRequest,
) => Promise<ChangePasswordResponse>;
